import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir8990ScheduleBService {

  constructor(private http: HttpClient) {}

  save8990ScheduleBAmounts(
    baseUrl: string,
    payload: { combination_key: string; acct_key: string; amount: string },
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=ak4spe`;

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    const jsonObj = [{
      combination_key: rowData.COMBINATION_KEY || payload.combination_key,
      acct_key: payload.acct_key,
      amount: payload.amount
    }];
    const jsonSettings = [{
      tax_year: rowData.TAX_YEAR ?? filterParams?.tax_year ?? globalService?.globalParams?.tax_year,
      scenario: filterParams?.scenario ?? globalService?.globalParams?.scenario,
      jcd_key: rowData.JCD_KEY ?? filterParams?.jcd_key ?? globalService?.globalParams?.jcd_key ?? 250
    }];

    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSetting: JSON.stringify(jsonSettings) }, params);

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
